<template>
  <span class="upload-file">
    <button
      :class="`btn btn-sm btn-info ${titleKey ? 'btn-icon' : ''} ${className}`"
    >
      <span :class="`ti-${icon}`"></span>
      <span v-if="titleKey">{{ titleKey | setText(title) }}</span>
      <input
        class="upload-file-main"
        ref="fileupload"
        type="file"
        @change="handleFileUpload"
      />
    </button>
  </span>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    newData: null,
    oldData: null,
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    className: {
      default: "",
    },
    icon: {
      default: "file",
    },
    value: {
      default: null,
    },
    result: {
      default: null,
    },
    titleKey: {
      default: null,
    },
    title: {
      default: null,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", null);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const reader = new FileReader();
        this.tempUpload = true;
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.newData = reader.result;
        });
        this.$emit("input", event.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss">
.upload-file {
  position: relative;
  &-main {
    position: absolute;
    opacity: 0;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
